<template>
  <div class="index">
    <router-view />
  </div>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed, defineComponent,defineExpose } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useInviteStore } from "@/store/invite";
const inviteStore = useInviteStore();
/**
* 路由对象
*/
const route = useRoute();
/**
* 路由实例
*/
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
* 数据部分
*/
const data = reactive({})

inviteStore.getTeamUserList();
inviteStore.getTeamInfo();
inviteStore.getWithdrawBalance();
inviteStore.setQuitMemberItem('levelOne')
onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
})
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
})
watchEffect(()=>{
})
// 使用toRefs解构
// let { } = { ...toRefs(data) } 
defineExpose({
  ...toRefs(data)
})

</script>
<style lang='scss' scoped>
::v-deep().inviteDialogClass {
  .title {
    margin-top: 48px;
    margin-bottom: 24px;
    text-align: center;
    font-weight: 500;
    color: #222222;
    font-size: 34px;
  }
  .centen {
    padding: 0 32px;
    font-weight: 400;
    color: #222222;
    font-size: 34px;
  }
  .btn {
    padding: 23px 0;
    text-align: center;
    background: #8368fc;
    border-radius: 44px;
    margin: 0 136px;
    font-weight: 400;
    color: #ffffff;
    line-height: 42px;
    font-size: 30px;
    margin-top: 64px;
    margin-bottom: 32px;
  }
}
</style>